import Api from '../../config/config.js'

export default {
    async attribuer(options){
        try {
            let postAttribution = await Api.instance.post(`/emargement/attribuer`,options)
            console.log("postAttribution",postAttribution)
            return postAttribution.data.create?true:false
        } catch (error) {
            console.log(error)
        }
    },
    async getAttr(options){
        try {
            let getAttrTrainer = await Api.instance.get(`/emargement/get-by-trainer`,{params:options})
            console.log("getAttrTrainer",getAttrTrainer)
            return getAttrTrainer.data
        } catch (error) {
            console.log(error)
        }
    },
    async getAdherent(options){
        try {
            let getAdherentByCreneau = await Api.instance.get(`/emargement/get-adherents-by-creneau`,{params:options})
            console.log("getAdherentByCreneau",getAdherentByCreneau)
            return getAdherentByCreneau.data
        } catch (error) {
            console.log(error)
        }
    },
    async saveEmargementLicencie(options){
        try {
            let saveEmargement = await Api.instance.get(`/emargement/save-by-creneau`,{params:options})
            console.log("saveEmargement",saveEmargement)
            return saveEmargement.data.save
        } catch (error) {
            console.log(error)
        }
    },
    async getEmargementByDate(options){
        try {
            let getByDateEmargement = await Api.instance.get(`/emargement/get-by-date`,{params:options})
            console.log("getByDateEmargement",getByDateEmargement)
            return getByDateEmargement.data
        } catch (error) {
            console.log(error)
        }
    },
    async suivreEmargementByDate(options){
        try {
            let suivreByDateEmargement = await Api.instance.get(`/emargement/suivre-by-date`,{params:options})
            console.log("suivreByDateEmargement",suivreByDateEmargement)
            return suivreByDateEmargement.data
        } catch (error) {
            console.log(error)
        }
    },
    async suivreEmargementByDateSalle(options){
        try {
            let suivreByDateSalleEmargement = await Api.instance.get(`/emargement/suivre-by-date-salle`,{params:options})
            console.log("suivreByDateSalleEmargement",suivreByDateSalleEmargement)
            return suivreByDateSalleEmargement.data
        } catch (error) {
            console.log(error)
        }
    },
}